import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
//Redux Actions Import
import { getFooterData } from '../../redux/footer/footerActions'
//MUI Imports
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
//Icons
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneIcon from '@material-ui/icons/Phone';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import TelegramIcon from '@material-ui/icons/Telegram';
import InstagramIcon from '@material-ui/icons/Instagram';
//My Components
import * as TextLoader from '../../components/StaticTexts/Index'
//Device Detect

const useStyles = makeStyles((theme) => ({
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1534
        }
    },
    base: {
        flexGrow: 1,
    },
    paperNoBg: {
        backgroundColor: 'transparent'
    },
    bgSection: {
        [theme.breakpoints.down('xs')]: {
            backgroundSize: 'cover',
            backgroundPosition: 'center center'
        }
    },
    logo: {
        [theme.breakpoints.up('sm')]: {
            paddingTop: '0px',
            marginTop: '-36px',
            marginBottom: '10px'
        },
        [theme.breakpoints.down('sm')]: {
            paddingTop: '0px',
            marginTop: '0px',
            marginBottom: '20px',
            textAlign: 'center',
        }
    }
}));

const Footer = ({ lang }) => {

    //Global
    const classes = useStyles();
    const [menuBg, setMenuBg] = useState('/images/footer/footer-bg.jpg');
    const [staticText, setStaticText] = useState({});
    const [tabletView, setTabletView] = useState(false)
    const [mobileView, setMobileView] = useState(false)
    //Redux
    const dispatch = useDispatch()
    const footer = useSelector(state => state.footerData)
    const { loading, error, address, phoneNumbers, workTime, shortAboutText } = footer

    useEffect(() => {
        const setResponsiveness = () => {
            if (window.innerWidth > 900) {
                setTabletView(false)
                setMobileView(false)
                setMenuBg('/images/footer/footer-bg.jpg')
            }
            else if (window.innerWidth < 901 && window.innerWidth > 477) {
                setTabletView(true)
                setMobileView(false)
                setMenuBg('/images/footer/mobileFooterBg.jpg')
            }
            else {
                setTabletView(false)
                setMobileView(true)
                setMenuBg('/images/footer/mobileFooterBg.jpg')
            }
        };
        setResponsiveness()
        window.addEventListener("resize", () => setResponsiveness())
        dispatch(getFooterData(lang))
        setStaticText(TextLoader.staticTextLoader('footer', lang))
    }, [dispatch])

    return (
        <Box overflow="hidden">
            <Grid container className={classes.base + ' footerMainSection ' + lang} justify="center" spacing={0} alignItems="center">
                <Grid justify="center" alignItems="top" className={classes.container} container spacing={0}>
                    <Grid item md={12} className="footer" className={classes.bgSection} style={{ backgroundImage: `url(${menuBg})` }}>
                        <Grid justify="center" container spacing={3} >
                            <Hidden only={['lg', 'md', 'sm', 'xl']}>
                                <Grid item xs={12} className="footerMask" style={{ backgroundImage: 'url(/images/footer/mask2.png)' }}>
                                    <img src="/images/footer/footerPistachio.png" style={{ marginLeft: '25px' }} />
                                </Grid>
                            </Hidden>
                            <Hidden only={['xs', 'sm']}>
                                <Grid item md={7} sm={7} xs={12}>
                                    <Paper elevation={0} className={classes.paperNoBg + ' text-left'}>
                                        <Box elevation={0} boxShadow={0} p={1} m={1}>
                                            <img src="/images/footer/footerPistachio.png" className="fpl" />
                                        </Box>
                                    </Paper>
                                </Grid>
                                <Grid item md={5} sm={5} xs={12}></Grid>
                            </Hidden>
                            <Grid item md={4} xs={12}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box className="Footerbox1" elevation={0} m={{ sm: 2 }} boxShadow={0} textAlign="center">
                                        <img alt="" src="/images/footer/logo.png" />
                                        <p>{((!loading) && (!error) && (shortAboutText)) ? shortAboutText : staticText.loadingText}</p>
                                    </Box>

                                </Paper>
                            </Grid>
                            <Grid item md={2} sm={4} xs={12}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box elevation={0} boxShadow={0} m={1} p={1}>
                                        <div>
                                            <h1 className="title link-title">{staticText.linkTitle}</h1>
                                            <Hidden only={['xs']}>
                                                <ul className="list-style-none" style={{ paddingRight: '0px' }}>
                                                    <li key={1}>
                                                        <Link to={staticText.link1Href} className="white-link">{staticText.link1}</Link>
                                                    </li>
                                                    <li key={2}>
                                                        <Link to={staticText.link2Href} className="white-link">{staticText.link2}</Link>
                                                    </li>
                                                    <li key={3}>
                                                        <Link to={staticText.link3Href} className="white-link">{staticText.link3}</Link>
                                                    </li>
                                                    <li key={4}>
                                                        <Link to={staticText.link4Href} className="white-link">{staticText.link4}</Link>
                                                    </li>
                                                    <li key={5}>
                                                        <Link to={staticText.link5Href} className="white-link">{staticText.link5}</Link>
                                                    </li>
                                                </ul>
                                            </Hidden>
                                            <Hidden only={['md', 'sm', 'lg', 'xl']}>
                                                <table className="linksTable">
                                                    <tr>
                                                        <td>
                                                            <Link to={staticText.link1href} className="link">{staticText.link1}</Link>
                                                            <Link to={staticText.link2href} className="link">{staticText.link2}</Link>
                                                        </td>
                                                        <td>
                                                            <Link to={staticText.link4href} className="link">{staticText.link4}</Link>
                                                            <Link to={staticText.link5href} className="link">{staticText.link5}</Link>
                                                        </td>
                                                        <td>
                                                            <Link to={staticText.link3href} className="link">{staticText.link3}</Link>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </Hidden>
                                        </div>
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box elevation={0} boxShadow={0} m={1} p={{ xs: '15px 15px 15px 15px' }}>
                                        <div>
                                            <h1>{staticText.addressSection}</h1>
                                            <ul className="list-style-none" style={{ paddingRight: '0px' }}>
                                                <li key={1}>
                                                    <span className="white-link">
                                                        <span className="position-icon" style={{ position: 'relative', top: '7px' }}><LocationOnIcon /></span> {(!loading && !error) ? address : staticText.loadingText}
                                                    </span>
                                                </li>
                                                <li key={2}>
                                                    <span className="white-link">
                                                        <span className="phone-icon" style={{ position: 'relative', top: '7px' }}> <PhoneIcon /></span>  {(!loading && !error) ? phoneNumbers : staticText.loadingText}
                                                    </span>
                                                </li>
                                                <li key={3}>
                                                    <span className="white-link">
                                                        <span className="email-icon" style={{ position: 'relative', top: '7px' }}><MailOutlineIcon /></span> &nbsp;info@ajilhassanpour.com
                                                        </span>
                                                </li>
                                                <li key={4} className="white-text">
                                                    <span className="clock-icon" style={{ position: 'relative', top: '7px' }}><AccessTimeIcon /></span>  &nbsp;{(!loading && !error) ? workTime : staticText.loadingText}
                                                </li>
                                            </ul>
                                        </div>
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item md={3} sm={6} xs={12}>
                                <Paper elevation={0} className={classes.paperNoBg}>
                                    <Box elevation={0} boxShadow={0} p={{ xs: '15px' }} textAlign="center">
                                        <div>
                                            <Hidden only={['xs', 'sm']}>
                                                <h1>{staticText.namadText}</h1>
                                                <div>
                                                    <Link className="namad" style={{ display: 'inline !important' }}>
                                                        <img src="/images/footer/enamad.png" />
                                                    </Link>
                                                    <Link className="smandehi" style={{ display: 'inline !important' }}>
                                                        <img src="/images/footer/smandehi.png" />
                                                    </Link>
                                                </div>
                                            </Hidden>
                                            <Hidden only={['xl', 'lg', 'sm', 'md']}>
                                                <p className="icons">
                                                    <a rel="nofollow" href='https://instagram.com/ajilhassanpour' target='_blank' className="instagram"><InstagramIcon /></a>
                                                    <a rel="nofollow" href='https://t.me/AjilHasanPour' target='_blank' className="telegram"><TelegramIcon /></a>
                                                </p>
                                            </Hidden>
                                            <p className="white-text">{staticText.followText}</p>
                                            <Hidden only={['xs']}>
                                                <p className="icons">
                                                    <a rel="nofollow" href='https://instagram.com/ajilhassanpour' target='_blank' className="instagram"><InstagramIcon /></a>
                                                    <a rel="nofollow" href='https://t.me/AjilHasanPour' target='_blank' className="telegram"><TelegramIcon /></a>
                                                </p>
                                            </Hidden>
                                            <Hidden only={['xl', 'lg', 'sm', 'md']}>
                                                <Box mt={0} textAlign="center">
                                                    <p style={{ marginTop: '0px', fontSize: '1rem' }}><a target="_blank" style={{ color: '#fff', fontSize: '0.9rem' }} href="https://www.asraweb.com/"><img style={{ height: '23px', position: 'relative', top: '5px' }} src="/images/asraweb-logo.png" /></a><span style={{ fontSize: '0.9rem', marginRight: '5px' }}></span></p>
                                                </Box>
                                            </Hidden>
                                        </div>

                                    </Box>

                                </Paper>
                            </Grid>
                            <Hidden only={['xs']}>
                                <Grid item md={12} xs={12} className={classes.logo} sm={12}>
                                    <Box mt={0} mr={3} mb={-2} textAlign="right">
                                        <p style={{ marginTop: '0px', fontSize: '1rem' }}><a target="_blank" style={{ color: '#fff', fontSize: '0.9rem' }} href="https://www.asraweb.com/"><img style={{ height: '23px', position: 'relative', top: '5px' }} src="/images/asraweb-logo.png" /></a><span style={{ fontSize: '0.9rem', marginRight: '5px' }}></span></p>
                                    </Box>
                                </Grid>
                            </Hidden>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )

}

Footer.propTypes = {
    lang: PropTypes.string
}

export default Footer
